<template>
  <div class="profile-tab-wrap">
    <a-tabs
      v-model="activeKey"
      @tabClick="handleTabClick"
      ref="tabs"
      :class="
        `${
          $route.params.id || onlyCollegeNormalCoach()
            ? 'hidden-route-tabs'
            : ''
        }`
      "
    >
      <a-tab-pane key="summary" tab="Profile Summary">
        <Summary />
      </a-tab-pane>
      <a-tab-pane key="basic_information" tab="Basic Information">
        <BasicInformation />
      </a-tab-pane>
      <a-tab-pane key="pictures" tab="Pictures">
        <Pictures />
      </a-tab-pane>
      <a-tab-pane key="videos" tab="Videos">
        <VideosListing v-if="routeMatch('listing')" />
        <Videos v-else />
      </a-tab-pane>
      <a-tab-pane key="academic_information" tab="Academic Information">
        <AcedemicInformation />
      </a-tab-pane>
      <a-tab-pane key="coaching_staffs" tab="Coaching Staff">
        <CoachingStaffs />
      </a-tab-pane>
      <a-tab-pane key="events" tab="Events">
        <Events />
      </a-tab-pane>
      <a-tab-pane key="team_highlights" tab="Highlights">
        <Highlight />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Summary from "./summary/summary";
import CoachingStaffs from "../index";
import Highlight from "../../college-team-highlights/index";
import BasicInformation from "./edit/basic-information";
import AcedemicInformation from "./edit/academic-information";
import Videos from "./edit/videos";
import Events from "@/views/college-events-list/index";
import VideosListing from "./edit/videos-listing";
import Pictures from "./edit/pictures";

import { Base } from "@/models";
const COLLEGE_STORE_KEY = "collegeStore";

export default {
  name: "ProfileView",
  components: {
    Summary,
    CoachingStaffs,
    BasicInformation,
    Highlight,
    AcedemicInformation,
    Videos,
    Events,
    VideosListing,
    Pictures
  },
  data() {
    return {
      activeKey: "summary"
    };
  },
  computed: {
    routeName() {
      const routes = this.$route.path.split("/");
      return routes[routes.length - 1];
    }
  },
  methods: {
    handleTabClick(e) {
      this.$router.push({
        path: `/${Base.profileId()}/college_profile/${e}`,
        query: { key: "college-profile" }
      });
    },
    routeMatch(params) {
      return this.$route.path.match(params) ? true : false;
    }
  },
  watch: {
    routeName: {
      immediate: true,
      handler: function(newVal, _) {
        this.activeKey = newVal;
      }
    }
  }
};
</script>
<style lang="sass">
.hidden-route-tabs
  .ant-tabs-nav
    .ant-tabs-tab
      display: none
</style>
